import httpClient from '@/api/http-client';

const endpoint = 'api/issued-vehicle-permits';

const issuedVehiclePermitsService = {
  // create: (permit) => httpClient.post(`${endpoint}`, permit),

  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),
};

export default issuedVehiclePermitsService;
